import VerifyOtpTemplate from "../../../templates/users/verifyOtp";

const VerifyOtpScreen = () => {
  return <VerifyOtpTemplate />;
};

export default VerifyOtpScreen;
